import React from "react";
import NoDataIcon from "./../../../assets/icons/NoData.svg";
import { isNonZero } from "@Helpers/numberCondition";

/** Every prop is optional: `dragList` passes only `text1`, `CreateTransmittal` adds width/height,
 *  and `svg` overrides the default icon. All have runtime fallbacks below. */
type NoDataSvgProps = {
  svg?: string;
  width?: number;
  height?: number;
  text1?: React.ReactNode;
  text2?: React.ReactNode;
  /** Font-size utility for `text1`; colour, weight and spacing stay fixed. */
  text1Size?: string;
};

const NoDataSvg = (props: NoDataSvgProps) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <img
        src={props.svg ? props.svg : NoDataIcon}
        alt="No data"
        width={isNonZero(props.width) ? props.width : 300}
        height={isNonZero(props.height) ? props.height : 300}
      />
      {props.text1 && (
        <div className={`text-text_light ${props.text1Size ?? "text-lg"} font-semibold mt-4 text-center`}>
          {props.text1}
        </div>
      )}
      {props.text2 && <div className="mt-2 text-center">{props.text2}</div>}
    </div>
  );
};

export default NoDataSvg;
